// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studio/v2/service.proto (package creativefabrica.studio.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Project, ProjectJson, TemplateType, TemplateTypeJson, UserBanStatus, UserBanStatusJson, VectorClock, VectorClockJson } from "./types_pb";
import { file_creativefabrica_studio_v2_types } from "./types_pb";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studio/v2/service.proto.
 */
export const file_creativefabrica_studio_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_studio_v2_types, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.studio.v2.MigrateProjectRequest
 */
export type MigrateProjectRequest = Message<"creativefabrica.studio.v2.MigrateProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * the schema version to migrate the project to.
   *
   * @generated from field: int32 schema_version = 2;
   */
  schemaVersion: number;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock client_vector_clock = 3;
   */
  clientVectorClock?: VectorClock | undefined;

  /**
   * the patch to apply to the project after migration.
   *
   * @generated from field: string new_body = 4;
   */
  newBody: string;
};

/**
 * @generated from message creativefabrica.studio.v2.MigrateProjectRequest
 */
export type MigrateProjectRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;

  /**
   * the schema version to migrate the project to.
   *
   * @generated from field: int32 schema_version = 2;
   */
  schemaVersion?: number;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock client_vector_clock = 3;
   */
  clientVectorClock?: VectorClockJson;

  /**
   * the patch to apply to the project after migration.
   *
   * @generated from field: string new_body = 4;
   */
  newBody?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.MigrateProjectRequest.
 * Use `create(MigrateProjectRequestSchema)` to create a new message.
 */
export const MigrateProjectRequestSchema: GenMessage<MigrateProjectRequest, {jsonType: MigrateProjectRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 0);

/**
 * @generated from message creativefabrica.studio.v2.ForceActivateRevisionRequest
 */
export type ForceActivateRevisionRequest = Message<"creativefabrica.studio.v2.ForceActivateRevisionRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * the revision id to force the project to.
   *
   * @generated from field: string revision_id = 2;
   */
  revisionId: string;
};

/**
 * @generated from message creativefabrica.studio.v2.ForceActivateRevisionRequest
 */
export type ForceActivateRevisionRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;

  /**
   * the revision id to force the project to.
   *
   * @generated from field: string revision_id = 2;
   */
  revisionId?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.ForceActivateRevisionRequest.
 * Use `create(ForceActivateRevisionRequestSchema)` to create a new message.
 */
export const ForceActivateRevisionRequestSchema: GenMessage<ForceActivateRevisionRequest, {jsonType: ForceActivateRevisionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 1);

/**
 * @generated from message creativefabrica.studio.v2.ForceActivateRevisionResponse
 */
export type ForceActivateRevisionResponse = Message<"creativefabrica.studio.v2.ForceActivateRevisionResponse"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClock | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.ForceActivateRevisionResponse
 */
export type ForceActivateRevisionResponseJson = {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClockJson;
};

/**
 * Describes the message creativefabrica.studio.v2.ForceActivateRevisionResponse.
 * Use `create(ForceActivateRevisionResponseSchema)` to create a new message.
 */
export const ForceActivateRevisionResponseSchema: GenMessage<ForceActivateRevisionResponse, {jsonType: ForceActivateRevisionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 2);

/**
 * @generated from message creativefabrica.studio.v2.MigrateProjectResponse
 */
export type MigrateProjectResponse = Message<"creativefabrica.studio.v2.MigrateProjectResponse"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClock | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.MigrateProjectResponse
 */
export type MigrateProjectResponseJson = {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClockJson;
};

/**
 * Describes the message creativefabrica.studio.v2.MigrateProjectResponse.
 * Use `create(MigrateProjectResponseSchema)` to create a new message.
 */
export const MigrateProjectResponseSchema: GenMessage<MigrateProjectResponse, {jsonType: MigrateProjectResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 3);

/**
 * @generated from message creativefabrica.studio.v2.GetProjectRequest
 */
export type GetProjectRequest = Message<"creativefabrica.studio.v2.GetProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * @generated from message creativefabrica.studio.v2.GetProjectRequest
 */
export type GetProjectRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema: GenMessage<GetProjectRequest, {jsonType: GetProjectRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 4);

/**
 * @generated from message creativefabrica.studio.v2.GetProjectResponse
 */
export type GetProjectResponse = Message<"creativefabrica.studio.v2.GetProjectResponse"> & {
  /**
   * @generated from field: creativefabrica.studio.v2.Project project = 1;
   */
  project?: Project | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.GetProjectResponse
 */
export type GetProjectResponseJson = {
  /**
   * @generated from field: creativefabrica.studio.v2.Project project = 1;
   */
  project?: ProjectJson;
};

/**
 * Describes the message creativefabrica.studio.v2.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema: GenMessage<GetProjectResponse, {jsonType: GetProjectResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 5);

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest
 */
export type ApplyPatchRequest = Message<"creativefabrica.studio.v2.ApplyPatchRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * all of the patch sets to apply in the request.
   *
   * @generated from field: repeated creativefabrica.studio.v2.ApplyPatchRequest.PatchSet patch_sets = 2;
   */
  patchSets: ApplyPatchRequest_PatchSet[];

  /**
   * the session id of the user making the request.
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * the schema version to apply the patch to.
   *
   * @generated from field: int32 schema_version = 4;
   */
  schemaVersion: number;
};

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest
 */
export type ApplyPatchRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;

  /**
   * all of the patch sets to apply in the request.
   *
   * @generated from field: repeated creativefabrica.studio.v2.ApplyPatchRequest.PatchSet patch_sets = 2;
   */
  patchSets?: ApplyPatchRequest_PatchSetJson[];

  /**
   * the session id of the user making the request.
   *
   * @generated from field: string session_id = 3;
   */
  sessionId?: string;

  /**
   * the schema version to apply the patch to.
   *
   * @generated from field: int32 schema_version = 4;
   */
  schemaVersion?: number;
};

/**
 * Describes the message creativefabrica.studio.v2.ApplyPatchRequest.
 * Use `create(ApplyPatchRequestSchema)` to create a new message.
 */
export const ApplyPatchRequestSchema: GenMessage<ApplyPatchRequest, {jsonType: ApplyPatchRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 6);

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest.PatchSet
 */
export type ApplyPatchRequest_PatchSet = Message<"creativefabrica.studio.v2.ApplyPatchRequest.PatchSet"> & {
  /**
   * the vector clock that the FE applied the incoming changes too
   *
   * @generated from field: creativefabrica.studio.v2.VectorClock client_vector_clock = 1;
   */
  clientVectorClock?: VectorClock | undefined;

  /**
   * all of the patches to apply in the request, the same patch could be included multiple times.
   *
   * @generated from field: repeated creativefabrica.studio.v2.ApplyPatchRequest.Patch patches = 2;
   */
  patches: ApplyPatchRequest_Patch[];
};

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest.PatchSet
 */
export type ApplyPatchRequest_PatchSetJson = {
  /**
   * the vector clock that the FE applied the incoming changes too
   *
   * @generated from field: creativefabrica.studio.v2.VectorClock client_vector_clock = 1;
   */
  clientVectorClock?: VectorClockJson;

  /**
   * all of the patches to apply in the request, the same patch could be included multiple times.
   *
   * @generated from field: repeated creativefabrica.studio.v2.ApplyPatchRequest.Patch patches = 2;
   */
  patches?: ApplyPatchRequest_PatchJson[];
};

/**
 * Describes the message creativefabrica.studio.v2.ApplyPatchRequest.PatchSet.
 * Use `create(ApplyPatchRequest_PatchSetSchema)` to create a new message.
 */
export const ApplyPatchRequest_PatchSetSchema: GenMessage<ApplyPatchRequest_PatchSet, {jsonType: ApplyPatchRequest_PatchSetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 6, 0);

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest.Patch
 */
export type ApplyPatchRequest_Patch = Message<"creativefabrica.studio.v2.ApplyPatchRequest.Patch"> & {
  /**
   * "add", "remove", "replace"
   *
   * @generated from field: string op = 1;
   */
  op: string;

  /**
   * JSON Pointer path https://datatracker.ietf.org/doc/html/rfc6901
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * The value to apply, only used for "add" and "replace".
   *
   * @generated from field: optional google.protobuf.Value value = 3;
   */
  value?: Value | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchRequest.Patch
 */
export type ApplyPatchRequest_PatchJson = {
  /**
   * "add", "remove", "replace"
   *
   * @generated from field: string op = 1;
   */
  op?: string;

  /**
   * JSON Pointer path https://datatracker.ietf.org/doc/html/rfc6901
   *
   * @generated from field: string path = 2;
   */
  path?: string;

  /**
   * The value to apply, only used for "add" and "replace".
   *
   * @generated from field: optional google.protobuf.Value value = 3;
   */
  value?: ValueJson;
};

/**
 * Describes the message creativefabrica.studio.v2.ApplyPatchRequest.Patch.
 * Use `create(ApplyPatchRequest_PatchSchema)` to create a new message.
 */
export const ApplyPatchRequest_PatchSchema: GenMessage<ApplyPatchRequest_Patch, {jsonType: ApplyPatchRequest_PatchJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 6, 1);

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchResponse
 */
export type ApplyPatchResponse = Message<"creativefabrica.studio.v2.ApplyPatchResponse"> & {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClock | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.ApplyPatchResponse
 */
export type ApplyPatchResponseJson = {
  /**
   * @generated from field: string revision_id = 1;
   */
  revisionId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 2;
   */
  vectorClock?: VectorClockJson;
};

/**
 * Describes the message creativefabrica.studio.v2.ApplyPatchResponse.
 * Use `create(ApplyPatchResponseSchema)` to create a new message.
 */
export const ApplyPatchResponseSchema: GenMessage<ApplyPatchResponse, {jsonType: ApplyPatchResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 7);

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectRequest
 */
export type CreateProjectRequest = Message<"creativefabrica.studio.v2.CreateProjectRequest"> & {
  /**
   * @generated from field: optional creativefabrica.studio.v2.CreateProjectRequest.Template template = 1;
   */
  template?: CreateProjectRequest_Template | undefined;

  /**
   * Schema FE the FE are currently on.
   *
   * @generated from field: int32 schema_version = 2;
   */
  schemaVersion: number;

  /**
   * the folder which to store the project in
   *
   * @generated from field: optional string folder_id = 3;
   */
  folderId?: string | undefined;

  /**
   * @generated from field: optional string team_id = 4;
   */
  teamId?: string | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectRequest
 */
export type CreateProjectRequestJson = {
  /**
   * @generated from field: optional creativefabrica.studio.v2.CreateProjectRequest.Template template = 1;
   */
  template?: CreateProjectRequest_TemplateJson;

  /**
   * Schema FE the FE are currently on.
   *
   * @generated from field: int32 schema_version = 2;
   */
  schemaVersion?: number;

  /**
   * the folder which to store the project in
   *
   * @generated from field: optional string folder_id = 3;
   */
  folderId?: string;

  /**
   * @generated from field: optional string team_id = 4;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema: GenMessage<CreateProjectRequest, {jsonType: CreateProjectRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 8);

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectRequest.Template
 */
export type CreateProjectRequest_Template = Message<"creativefabrica.studio.v2.CreateProjectRequest.Template"> & {
  /**
   * id of the template this project was created from
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * the type of template
   *
   * @generated from field: creativefabrica.studio.v2.TemplateType template_type = 2;
   */
  templateType: TemplateType;
};

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectRequest.Template
 */
export type CreateProjectRequest_TemplateJson = {
  /**
   * id of the template this project was created from
   *
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * the type of template
   *
   * @generated from field: creativefabrica.studio.v2.TemplateType template_type = 2;
   */
  templateType?: TemplateTypeJson;
};

/**
 * Describes the message creativefabrica.studio.v2.CreateProjectRequest.Template.
 * Use `create(CreateProjectRequest_TemplateSchema)` to create a new message.
 */
export const CreateProjectRequest_TemplateSchema: GenMessage<CreateProjectRequest_Template, {jsonType: CreateProjectRequest_TemplateJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 8, 0);

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectResponse
 */
export type CreateProjectResponse = Message<"creativefabrica.studio.v2.CreateProjectResponse"> & {
  /**
   * @generated from field: creativefabrica.studio.v2.Project project = 1;
   */
  project?: Project | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.CreateProjectResponse
 */
export type CreateProjectResponseJson = {
  /**
   * @generated from field: creativefabrica.studio.v2.Project project = 1;
   */
  project?: ProjectJson;
};

/**
 * Describes the message creativefabrica.studio.v2.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema: GenMessage<CreateProjectResponse, {jsonType: CreateProjectResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 9);

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectRequest
 */
export type UpdateProjectRequest = Message<"creativefabrica.studio.v2.UpdateProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields update_fields = 2;
   */
  updateFields?: UpdateProjectRequest_UpdateFields | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectRequest
 */
export type UpdateProjectRequestJson = {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields update_fields = 2;
   */
  updateFields?: UpdateProjectRequest_UpdateFieldsJson;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMaskJson;
};

/**
 * Describes the message creativefabrica.studio.v2.UpdateProjectRequest.
 * Use `create(UpdateProjectRequestSchema)` to create a new message.
 */
export const UpdateProjectRequestSchema: GenMessage<UpdateProjectRequest, {jsonType: UpdateProjectRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 10);

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields
 */
export type UpdateProjectRequest_UpdateFields = Message<"creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string folder_id = 2;
   */
  folderId: string;
};

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields
 */
export type UpdateProjectRequest_UpdateFieldsJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string folder_id = 2;
   */
  folderId?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.UpdateProjectRequest.UpdateFields.
 * Use `create(UpdateProjectRequest_UpdateFieldsSchema)` to create a new message.
 */
export const UpdateProjectRequest_UpdateFieldsSchema: GenMessage<UpdateProjectRequest_UpdateFields, {jsonType: UpdateProjectRequest_UpdateFieldsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 10, 0);

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectResponse
 */
export type UpdateProjectResponse = Message<"creativefabrica.studio.v2.UpdateProjectResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string folder_id = 3;
   */
  folderId?: string | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 4;
   */
  updateTime?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.UpdateProjectResponse
 */
export type UpdateProjectResponseJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string folder_id = 3;
   */
  folderId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 4;
   */
  updateTime?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studio.v2.UpdateProjectResponse.
 * Use `create(UpdateProjectResponseSchema)` to create a new message.
 */
export const UpdateProjectResponseSchema: GenMessage<UpdateProjectResponse, {jsonType: UpdateProjectResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 11);

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionRequest
 */
export type RollbackEditorVersionRequest = Message<"creativefabrica.studio.v2.RollbackEditorVersionRequest"> & {
  /**
   * @generated from oneof creativefabrica.studio.v2.RollbackEditorVersionRequest.target
   */
  target: {
    /**
     * Option 1: A list of specific project IDs to rollback.
     *
     * @generated from field: creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget project_ids = 1;
     */
    value: RollbackEditorVersionRequest_ProjectListTarget;
    case: "projectIds";
  } | {
    /**
     * Option 2: A boolean flag to indicate an emergency rollback across ALL projects.
     *
     * @generated from field: bool rollback_all = 2;
     */
    value: boolean;
    case: "rollbackAll";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionRequest
 */
export type RollbackEditorVersionRequestJson = {
  /**
   * Option 1: A list of specific project IDs to rollback.
   *
   * @generated from field: creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget project_ids = 1;
   */
  projectIds?: RollbackEditorVersionRequest_ProjectListTargetJson;

  /**
   * Option 2: A boolean flag to indicate an emergency rollback across ALL projects.
   *
   * @generated from field: bool rollback_all = 2;
   */
  rollbackAll?: boolean;
};

/**
 * Describes the message creativefabrica.studio.v2.RollbackEditorVersionRequest.
 * Use `create(RollbackEditorVersionRequestSchema)` to create a new message.
 */
export const RollbackEditorVersionRequestSchema: GenMessage<RollbackEditorVersionRequest, {jsonType: RollbackEditorVersionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 12);

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget
 */
export type RollbackEditorVersionRequest_ProjectListTarget = Message<"creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget"> & {
  /**
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[];
};

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget
 */
export type RollbackEditorVersionRequest_ProjectListTargetJson = {
  /**
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds?: string[];
};

/**
 * Describes the message creativefabrica.studio.v2.RollbackEditorVersionRequest.ProjectListTarget.
 * Use `create(RollbackEditorVersionRequest_ProjectListTargetSchema)` to create a new message.
 */
export const RollbackEditorVersionRequest_ProjectListTargetSchema: GenMessage<RollbackEditorVersionRequest_ProjectListTarget, {jsonType: RollbackEditorVersionRequest_ProjectListTargetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 12, 0);

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionResponse
 */
export type RollbackEditorVersionResponse = Message<"creativefabrica.studio.v2.RollbackEditorVersionResponse"> & {
  /**
   * @generated from field: int32 projects_rolled_back_count = 1;
   */
  projectsRolledBackCount: number;

  /**
   * @generated from field: repeated string project_id = 2;
   */
  projectId: string[];
};

/**
 * @generated from message creativefabrica.studio.v2.RollbackEditorVersionResponse
 */
export type RollbackEditorVersionResponseJson = {
  /**
   * @generated from field: int32 projects_rolled_back_count = 1;
   */
  projectsRolledBackCount?: number;

  /**
   * @generated from field: repeated string project_id = 2;
   */
  projectId?: string[];
};

/**
 * Describes the message creativefabrica.studio.v2.RollbackEditorVersionResponse.
 * Use `create(RollbackEditorVersionResponseSchema)` to create a new message.
 */
export const RollbackEditorVersionResponseSchema: GenMessage<RollbackEditorVersionResponse, {jsonType: RollbackEditorVersionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 13);

/**
 * @generated from message creativefabrica.studio.v2.SetUserBanStatusRequest
 */
export type SetUserBanStatusRequest = Message<"creativefabrica.studio.v2.SetUserBanStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.UserBanStatus ban_status = 2;
   */
  banStatus: UserBanStatus;

  /**
   * e.g. "automoderation", "admin_ui"
   *
   * @generated from field: optional string source = 3;
   */
  source?: string | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.SetUserBanStatusRequest
 */
export type SetUserBanStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.UserBanStatus ban_status = 2;
   */
  banStatus?: UserBanStatusJson;

  /**
   * e.g. "automoderation", "admin_ui"
   *
   * @generated from field: optional string source = 3;
   */
  source?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.SetUserBanStatusRequest.
 * Use `create(SetUserBanStatusRequestSchema)` to create a new message.
 */
export const SetUserBanStatusRequestSchema: GenMessage<SetUserBanStatusRequest, {jsonType: SetUserBanStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 14);

/**
 * @generated from message creativefabrica.studio.v2.SetUserBanStatusResponse
 */
export type SetUserBanStatusResponse = Message<"creativefabrica.studio.v2.SetUserBanStatusResponse"> & {
};

/**
 * @generated from message creativefabrica.studio.v2.SetUserBanStatusResponse
 */
export type SetUserBanStatusResponseJson = {
};

/**
 * Describes the message creativefabrica.studio.v2.SetUserBanStatusResponse.
 * Use `create(SetUserBanStatusResponseSchema)` to create a new message.
 */
export const SetUserBanStatusResponseSchema: GenMessage<SetUserBanStatusResponse, {jsonType: SetUserBanStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 15);

/**
 * @generated from message creativefabrica.studio.v2.GetUserBanStatusRequest
 */
export type GetUserBanStatusRequest = Message<"creativefabrica.studio.v2.GetUserBanStatusRequest"> & {
  /**
   * if not set, the get request will check the logged in user ban status.
   *
   * @generated from field: optional string user_id = 1;
   */
  userId?: string | undefined;
};

/**
 * @generated from message creativefabrica.studio.v2.GetUserBanStatusRequest
 */
export type GetUserBanStatusRequestJson = {
  /**
   * if not set, the get request will check the logged in user ban status.
   *
   * @generated from field: optional string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.GetUserBanStatusRequest.
 * Use `create(GetUserBanStatusRequestSchema)` to create a new message.
 */
export const GetUserBanStatusRequestSchema: GenMessage<GetUserBanStatusRequest, {jsonType: GetUserBanStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 16);

/**
 * @generated from message creativefabrica.studio.v2.GetUserBanStatusResponse
 */
export type GetUserBanStatusResponse = Message<"creativefabrica.studio.v2.GetUserBanStatusResponse"> & {
  /**
   * @generated from field: creativefabrica.studio.v2.UserBanStatus ban_status = 1;
   */
  banStatus: UserBanStatus;
};

/**
 * @generated from message creativefabrica.studio.v2.GetUserBanStatusResponse
 */
export type GetUserBanStatusResponseJson = {
  /**
   * @generated from field: creativefabrica.studio.v2.UserBanStatus ban_status = 1;
   */
  banStatus?: UserBanStatusJson;
};

/**
 * Describes the message creativefabrica.studio.v2.GetUserBanStatusResponse.
 * Use `create(GetUserBanStatusResponseSchema)` to create a new message.
 */
export const GetUserBanStatusResponseSchema: GenMessage<GetUserBanStatusResponse, {jsonType: GetUserBanStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_service, 17);

/**
 * @generated from service creativefabrica.studio.v2.StudioService
 */
export const StudioService: GenService<{
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof GetProjectRequestSchema;
    output: typeof GetProjectResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.ApplyPatch
   */
  applyPatch: {
    methodKind: "unary";
    input: typeof ApplyPatchRequestSchema;
    output: typeof ApplyPatchResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.MigrateProject
   */
  migrateProject: {
    methodKind: "unary";
    input: typeof MigrateProjectRequestSchema;
    output: typeof MigrateProjectResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.ForceActivateRevision
   */
  forceActivateRevision: {
    methodKind: "unary";
    input: typeof ForceActivateRevisionRequestSchema;
    output: typeof ForceActivateRevisionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof CreateProjectRequestSchema;
    output: typeof CreateProjectResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.UpdateProject
   */
  updateProject: {
    methodKind: "unary";
    input: typeof UpdateProjectRequestSchema;
    output: typeof UpdateProjectResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.RollbackEditorVersion
   */
  rollbackEditorVersion: {
    methodKind: "unary";
    input: typeof RollbackEditorVersionRequestSchema;
    output: typeof RollbackEditorVersionResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.SetUserBanStatus
   */
  setUserBanStatus: {
    methodKind: "unary";
    input: typeof SetUserBanStatusRequestSchema;
    output: typeof SetUserBanStatusResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.studio.v2.StudioService.GetUserBanStatus
   */
  getUserBanStatus: {
    methodKind: "unary";
    input: typeof GetUserBanStatusRequestSchema;
    output: typeof GetUserBanStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studio_v2_service, 0);

